import React from "react";
import Img from "gatsby-image";
import Zoom from "react-medium-image-zoom";
import classNames from "classnames";

const Image = ({ src, size, alt, caption, fluidResult, width }) => {
  const getImageClass = () => {
    switch (size) {
      case "default":
        return "default-size-image";
      case "medium":
        return "medium-size-image";
      case "large":
        return "large-size-image";
    }
  };

  // * Default width is set to 768 because if image's width is >= to 768 we set width to 100%
  // * otherwise we give orignal width of image

  const imageWidth = width ? parseInt(width) : 768;

  return fluidResult ? (
    <>
      <figure className={getImageClass()}>
        <Zoom wrapStyle={{ width: "100%" }}>
          <Img
            className={classNames("mx-auto max-w-full post-content-image", {
              "gatsby-image-small": imageWidth < 768,
            })}
            style={{ width: imageWidth >= 768 ? "100%" : imageWidth }}
            fluid={fluidResult}
            imgStyle={{ objectFit: "contain" }}
            alt={alt ? alt : ""}
          ></Img>
        </Zoom>
        {caption && (
          <figcaption
            dangerouslySetInnerHTML={{ __html: caption }}
          ></figcaption>
        )}
      </figure>
    </>
  ) : (
    <figure className={getImageClass()}>
      <Zoom wrapStyle={{ width: "100%" }}>
        <img className="post-content-image" src={src} alt={alt ? alt : ""} />
      </Zoom>
      {caption && (
        <figcaption dangerouslySetInnerHTML={{ __html: caption }}></figcaption>
      )}
    </figure>
  );
};

export default Image;
